import { type ReactElement } from 'react';
import { AgGrid, useTranslation } from '@common';
import styles from '../style.module.less';
import type { AgGridType } from '@common';
import type { RuleColumnValue, RuleProps } from '../types';

/**
 * 确认导入规则，上传导入文件
 */
export function Rule(props: RuleProps): ReactElement | null {
  const { t } = useTranslation();
  if (props.step !== 0) {
    return null;
  }

  const columns: AgGridType.ColDef[] = [
    {
      field: 'name',
      headerName: t('列名'),
      sortable: false
    },
    {
      field: 'validator',
      headerName: t('必填'),
      width: 80,
      sortable: false,
      valueFormatter: (params: RuleColumnValue) => ((params.value ?? []).some((item: { type: string }) => item.type === 'required') ? t('是') : t('否'))
    },
    {
      field: 'description',
      sortable: false,
      headerName: t('规则'),
      flex: 1
    }
  ];

  return (
    <div className={styles.stepContent}>
      <AgGrid
        height={300}
        pagination={false}
        columns={columns}
        defaultColDef={{
          filter: false,
          editable: false,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true
        }}
        data={props.definitions}
      />
    </div>
  );
}
